export const methods_index = ['methods.index']
export const methods_create = ['methods.create']
export const methods_edit = ['methods.edit']

export default [].concat(
    methods_index,
    methods_create,
    methods_edit
)
